export function adjustMasthead() {
    var masthead = document.querySelector('.masthead');
    if (!masthead) return; // Exit if masthead doesn't exist

    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var mastheadHeight = masthead.offsetHeight;

    // Find the .site-farlo-ui-crm element within .masthead
    var farloUI = masthead.querySelector('.site-farlo-ui-crm');

    if (windowWidth > 1300 && windowHeight > 600 && windowWidth < 2000 && windowHeight < 1000) {
        // Calculate the scale ratio
        var scale = Math.min(windowWidth / masthead.offsetWidth, windowHeight / masthead.offsetHeight) * 1.1;
        var translateY = (windowHeight - mastheadHeight * scale) / 2 + 50;
        // Apply the scale transformation to the masthead
        masthead.style.transform = `scale(${scale}) translateY(${translateY}px)`;
        masthead.style.transformOrigin = 'top center';

        // Calculate the scaled masthead height
        var scaledMastheadHeight = mastheadHeight * scale;


        // Calculate margin-bottom value to remove empty space
        var marginBottom = (scaledMastheadHeight - mastheadHeight) + 40;

        // Apply margin-bottom to the masthead
        masthead.style.marginBottom = `${marginBottom}px`;

        // Counteract the scale and maintain existing translation for .site-farlo-ui-crm
        if (farloUI) {
            farloUI.style.transform = `translate(-50%, -50%) scale(${1 / scale})`;
            farloUI.style.transformOrigin = 'center';
        }
    } else {
        // Reset transformations and masthead margin when not applicable
        masthead.style.transform = 'none';
        masthead.style.marginBottom = '0';
    }
}